import { render, staticRenderFns } from "./MemberItem.vue?vue&type=template&id=3ca4ef6f&scoped=true"
import script from "./MemberItem.vue?vue&type=script&lang=js"
export * from "./MemberItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca4ef6f",
  null
  
)

export default component.exports